const initialState = {
    masterSchemeIntialID:"",
    
    

};

const masterSchemeReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case "masterScheme_Id_Store":
            return {
                
                ...state,
                masterSchemeIntialID: payload,
            };
           
            
        default:
            return state;
    }
};

export default masterSchemeReducer;
